import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ModalService } from 'app/shared/services/modal/modal.service';
import { ImageLibraryCropperModalComponent } from 'app/shared/components/image-library-cropper-modal/image-library-cropper-modal.component';
import { FormControl } from '@angular/forms';
import { ImageService } from 'app/shared/services/image/image.service';
import { WalkthroughService } from '../../../services/walkthrough/walkthrough.service';

@Component({
  selector: 'tog-promo-library-cropper-modal',
  templateUrl: './promo-library-cropper-modal.component.html',
  styleUrls: ['./promo-library-cropper-modal.component.scss']
})
export class PromoLibraryCropperModalComponent extends ImageLibraryCropperModalComponent {
  @Input() typeForm: FormControl;
  @Output() typeChanged: EventEmitter<any> = new EventEmitter();

  promoTypes = [{ type: 'full-page', displayName: 'Full Page', ratio: [22, 35] },
               { type: 'half-page', displayName: 'Half Page', ratio: [1, 1] },
               { type: 'banner', displayName: 'Banner', ratio: [5, 2] }];

  constructor(public modal: ModalService, public imageService: ImageService, public walkthroughService: WalkthroughService) {
    super(modal, imageService, walkthroughService);
  }

  imageSelected(imageUrl: string) { }

  show() {
    this.libraryHidden = this.libraryExpanded = false;
    this.modal.show('image-library-cropper');
    if (this.typeForm.value == '') this.setAspectRatioAndEmit([22, 35], 'full-page');
    else {
      for (let i = 0; i < this.promoTypes.length; i++) {
        let promoType = this.promoTypes[i];
        if (promoType.type == this.typeForm.value) {
          this.setAspectRatioAndEmit(promoType.ratio, promoType.type);
          return;
        }
      }
    }
  }

  hide() {
    this.modal.hide();
  }

  setAspectRatioAndEmit(ratio: number[], type: string) {
    this.cropper.setAspectRatioFromDimensions(ratio[0], ratio [1]);
    this.typeForm.setValue(type);
    this.typeChanged.emit(type);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/image-library-cropper-modal/promo-image-library-cropper-modal/promo-library-cropper-modal.component.ts